<template>
  <div class="van-page">
    <the-header title="消息" />
    <van-list class="van-container" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDataList">
      <div class="van-section" v-for="(item, index) in listData" :key="index" @click="checkMsg(item);item.STATE='1'">
        <div class="van-section__header">
          <div class="van-section__title">
            <van-icon name="ri ri-notification-2-line" :dot="item.STATE!=='1'"></van-icon>
            <span class="label">消息提醒</span>
          </div>
          <span class="van-section__time">{{ item.CREATE_TIME }}</span>
        </div>
        <div class="van-section__body">
          <span style="color: #868997;">
            {{ item.NOTIFY_MSG }}
          </span>
        </div>
        <div class="van-section__footer">
          <span>查看详情</span>
        </div>

      </div>
    </van-list>

    <gz-footer></gz-footer>
  </div>
</template>
  
<script>
import { getNotifyMsg, updateNotifyMsg } from '@/api/interface/message'
export default {
  components: {
    'the-header': () => import('@/components/TheHeader'),
    'gz-footer': () => import('@/components/GzFooter'),
  },
  data() {
    return {

      pageNo: 1,
      loading: false,
      finished: false,
      listData: []
    }
  },
  methods: {
    getDataList() {
      const instance = new getNotifyMsg({
        userId: this.$store.getters.getUser.userId,
        page: this.pageNo++,
        rows: window.config.pageSize,
      })
      instance
        .then((result) => {
          const data = result.data.data.rows.map(item => {
            let data = item.cell
            const date = new Date(data.CREATE_TIME)
            data.CREATE_TIME = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
            return data
          })
          if (data.length > 0) {
            this.listData = this.listData.concat(data)
            this.loading = false
            if (this.listData.length >= result.data.data.total) {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true
          }
        }).catch((err) => {
          this.$dialog.alert({
              message: err+' 请联系开发人员'
            })
            this.loading = false
            this.finished = true
        });
    },
    checkMsg(item) {
      const instance = new updateNotifyMsg({
        id: item.ID
      })
      instance
        .then((result) => {
          if(item.NOTIFY_TYPE=='1'){
            this.$router.replace({ name: 'manager'})
          }else if(item.NOTIFY_TYPE=='0'){
            this.$router.replace({ name: 'code'})
          }
        }).catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>
  
<style lang="less" scoped>
.van-page {
  padding-bottom: 60px;
}

.van-container {
  padding: 12px 16px;
}

.van-section {
  padding: 0 12px;
  background: #fff;
  margin-bottom: 12px;
  border-radius: 6px;
  position: relative;
  font-size: 14px;
}

.van-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}

.van-section__title {
  display: flex;
  align-items: center;
  gap: 10px;

  .van-icon {
    height: 28px;
    width: 28px;
    font-size: 18px;
    background: #427AF4;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.van-section__body {
  padding: 0 0 12px 0;

}

.van-section__footer {
  border-top: 1px solid #EAEBEE;
  padding: 12px 0;
}

.van-section__time {
  color: #868997;
}</style>